<main class="landing-main">
  <header class="landing-topbar">
    <div class="auth-logo mb-2 text-decoration-none d-inline-block" aria-label="AI Campus"></div>
    <div class="landing-status">
      <span class="landing-status-dot" aria-hidden="true"></span>
      <span>{{ statusMessage }}</span>
    </div>
  </header>

  <div class="landing-content">
    <section class="landing-copy">
      <div class="landing-eyebrow">{{ heroContent.eyebrow }}</div>
      <h2>
        {{ heroContent.headlinePrefix }}
        <span class="accent">{{ heroContent.headlineAccent }}</span>
        {{ heroContent.headlineSuffix }}
      </h2>
      <p>
        {{ heroContent.description }}
      </p>

      <div class="landing-actions">
        <a :href="heroContent.primaryLink" class="landing-button landing-button-primary">
          {{ heroContent.primaryCta }}
        </a>
        <a :href="heroContent.secondaryLink" class="landing-button landing-button-secondary">
          {{ heroContent.secondaryCta }}
        </a>
      </div>
    </section>

    <section class="landing-preview" aria-label="Platform performance preview">
      <h3 class="landing-preview-title">{{ previewTitle }}</h3>

      <div class="landing-panels">
        <article class="landing-card landing-card-large landing-card-growth">
          <h3>Value-Driven Revenue Growth</h3>
          <div class="landing-chart" aria-hidden="true">
            <svg viewBox="0 0 360 210" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="growthFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stop-color="rgba(111, 198, 255, 0.42)" />
                  <stop offset="100%" stop-color="rgba(255, 255, 255, 0.02)" />
                </linearGradient>
              </defs>
              <g stroke="rgba(255,255,255,0.12)">
                <path d="M28 22V182H330" />
                <path d="M28 146H330" />
                <path d="M28 105H330" />
                <path d="M28 64H330" />
              </g>
              <path d="M40 164L108 116L180 108L252 92L322 48L322 182L40 182Z" fill="url(#growthFill)" />
              <path d="M40 164L108 116L180 108L252 92L322 48" stroke="#78b8ff" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" />
              <g fill="#78b8ff">
                <circle cx="40" cy="164" r="5" />
                <circle cx="108" cy="116" r="5" />
                <circle cx="180" cy="108" r="5" />
                <circle cx="252" cy="92" r="5" />
                <circle cx="322" cy="48" r="5" />
              </g>
            </svg>

            <div class="landing-chart-labels">
              <span class="landing-chart-label" style="left: 24px; top: 118px;">5011</span>
              <span class="landing-chart-label" style="left: 88px; top: 72px;">3,779</span>
              <span class="landing-chart-label" style="left: 160px; top: 62px;">2,792</span>
              <span class="landing-chart-label" style="left: 234px; top: 48px;">2,799</span>
              <span class="landing-chart-label" style="right: 0; top: 4px;">$1.098</span>
              <span class="landing-chart-label" style="left: 42%; bottom: 0;">Total Opportunities</span>
            </div>
          </div>
        </article>

        <article class="landing-card landing-card-large landing-card-progress">
          <h3>Milestone Completion Progress</h3>
          <div class="landing-progress-bars">
            <div class="landing-progress-row" v-for="item in milestones" :key="item.label">
              <span>{{ item.label }}</span>
              <div class="landing-progress-track">
                <div class="landing-progress-fill" :style="{ width: item.value + '%' }"></div>
              </div>
              <strong>{{ item.value }}%</strong>
            </div>
          </div>
        </article>

        <article class="landing-card landing-card-small landing-card-integrated">
          <h3>AIC One &amp; Proba Integrated</h3>
          <div class="landing-network" aria-hidden="true">
            <svg viewBox="0 0 220 170" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <radialGradient id="portalGlow" cx="50%" cy="50%" r="60%">
                  <stop offset="0%" stop-color="rgba(255,255,255,0.9)" />
                  <stop offset="40%" stop-color="rgba(255,161,111,0.45)" />
                  <stop offset="100%" stop-color="rgba(255,161,111,0)" />
                </radialGradient>
              </defs>
              <rect x="18" y="92" width="54" height="42" rx="10" fill="rgba(158,111,255,0.22)" stroke="rgba(255,255,255,0.12)" />
              <rect x="148" y="92" width="54" height="42" rx="10" fill="rgba(111,255,184,0.18)" stroke="rgba(255,255,255,0.12)" />
              <ellipse cx="110" cy="96" rx="34" ry="22" fill="url(#portalGlow)" />
              <ellipse cx="110" cy="96" rx="24" ry="14" fill="none" stroke="rgba(255,255,255,0.42)" stroke-width="2" />
              <path d="M72 110C92 84 128 84 148 110" fill="none" stroke="rgba(255,255,255,0.24)" stroke-width="3" stroke-linecap="round" />
              <path d="M72 118C92 142 128 142 148 118" fill="none" stroke="rgba(255,255,255,0.24)" stroke-width="3" stroke-linecap="round" />
              <path d="M92 56c8-10 28-10 36 0" fill="none" stroke="#67d68a" stroke-width="3" stroke-linecap="round" />
              <path d="M128 136c-8 10-28 10-36 0" fill="none" stroke="#67d68a" stroke-width="3" stroke-linecap="round" />
            </svg>
          </div>
          <div class="landing-integrated-footer">
            <span>AIC One Integrated</span>
            <span>Proba summaries</span>
          </div>
        </article>

        <article class="landing-card landing-card-small landing-card-library">
          <h3>Outcome library</h3>
          <div class="landing-library-items">
            <div class="landing-library-item" v-for="template in templates" :key="template">
              <span>{{ template }}</span>
              <span class="landing-library-star">&#9733;</span>
            </div>
          </div>
        </article>

        <article class="landing-card landing-card-small landing-card-score">
          <h3>Impact Visibility Score</h3>
          <div class="landing-gauge" aria-hidden="true">
            <svg viewBox="0 0 220 170" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="gaugeStroke" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stop-color="#c62d2d" />
                  <stop offset="100%" stop-color="#ef5656" />
                </linearGradient>
              </defs>
              <circle cx="110" cy="88" r="48" fill="none" stroke="rgba(255,255,255,0.08)" stroke-width="16" />
              <path d="M68 114A48 48 0 1 1 145 53" fill="none" stroke="url(#gaugeStroke)" stroke-width="16" stroke-linecap="round" />
              <circle cx="110" cy="88" r="58" fill="none" stroke="rgba(255,255,255,0.06)" stroke-width="1.5" stroke-dasharray="5 7" />
              <text x="110" y="95" fill="#f7e8dd" text-anchor="middle" font-size="28" font-weight="700">75%</text>
            </svg>
          </div>

          <div class="landing-gauge-labels">
            <span class="landing-pill">Category 1</span>
            <span class="landing-pill">Category 2</span>
            <span class="landing-pill">Category 3</span>
          </div>
        </article>
      </div>
    </section>
  </div>

</main>
